module.exports = __webpack_public_path__ + "static/media/login.3e7a5a77.jpg";